module.exports = __webpack_public_path__ + "img/home-page-app.61aeea9c.png";